// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__JYS4o","closeIcon":"tag_closeIcon__oDAW4"};